// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentLayout_container__1rHyA","header":"ContentLayout_header__WfFzI","content":"ContentLayout_content__2BUYQ"};